import React, {Component} from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import SearchResultRow from './SearchResultRow.js';
import Button from '@material-ui/core/Button';
import {withStyles} from "@material-ui/core";

const styles = theme => ({
    resultLink: {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }
});

class SearchResults extends Component {

    render() {

        const {searchResults,
            inventoryType,
            searchResultsTotalRecords,
            searchResultsTotalPages,
            searchResultsCurrentPage,
            handleSearch,
            handleDetailsSelection,
            searchResultsError,
            classes
        } = this.props;

        if (searchResultsError) {
            return <Typography variant='h3' align='center'>Error: {searchResultsError.message}</Typography>
        }

        if (searchResults == null) {
            return "";
        }

        if (searchResults.length === 0) {
            return (<Paper style={{padding: "10px", marginTop: "10px"}}><Typography variant='h5' align='center'>No results found</Typography></Paper>);
        } else {
            let backButton = <Button disabled={searchResultsCurrentPage <= 1} onClick={()=>{handleSearch(searchResultsCurrentPage-1)}} variant="contained" size="small" color="primary">Back</Button>;
            let forwardButton = <Button disabled={(searchResultsCurrentPage >= searchResultsTotalPages)} onClick={()=>{handleSearch(searchResultsCurrentPage+1)}} variant="contained" size="small" color="primary">Next</Button>;

            return (
                <Paper style={{padding: "10px", marginTop: "10px"}}>
                    <span style={{display: "none"}}>{searchResultsTotalRecords} total results</span>
                    <Typography variant='body1'>Page {searchResultsCurrentPage} out of {searchResultsTotalPages}</Typography>
                    {backButton} {forwardButton} <br/>
                    <br/>
                    <Grid container spacing={24}>
                        {
                            searchResults.map((element, index) => {
                                return (<SearchResultRow classes={classes} inventoryType={inventoryType} handleDetailsSelection={handleDetailsSelection} key={index} element={element} index={index}/>);
                            })
                        }
                    </Grid>
                    <Typography variant='body1'>Page {searchResultsCurrentPage} out of {searchResultsTotalPages}</Typography>
                    {backButton} {forwardButton} <br/>
                </Paper>)
        }
    }
}

export default withStyles(styles)(SearchResults);

